import { ISectionCardData } from '../fi-section-card/fi-section-card';
import { FiChecklistSectionTypes } from './checklist-types';

export const checklistEditDefaultSections: ISectionCardData[] = [
    {
        id: FiChecklistSectionTypes.General,
        headerTextLabel: '',
        subheaderTextLabel: '',
        //messageTextLabel: '',
        isAvailable: true,
    },
    {
        id: FiChecklistSectionTypes.ComplianceThreshold,
        headerTextLabel: 'checklist.compliance_threshold',
        subheaderTextLabel: 'checklist.set_compliance_threshold',
        isAvailable: true,
    },
    {
        id: FiChecklistSectionTypes.QRCodes,
        headerTextLabel: 'qr_common.qr_codes',
        subheaderTextLabel: 'qr_common.qr_code_description',
        //messageTextLabel: '',
        isAvailable: true,
    },
    {
        id: FiChecklistSectionTypes.Checkpoints,
        headerTextLabel: 'checklist.checkpoints',
        subheaderTextLabel: 'checklist.checkpoints_description',
        //messageTextLabel: 'checklist.checkpoints_message',
        isAvailable: true,
    },
    {
        id: FiChecklistSectionTypes.Settings,
        headerTextLabel: 'sharing_settings',
        subheaderTextLabel: 'checklist.sharing_settings_description',
        //messageTextLabel: 'checklist.sharing_settings_message',
        isAvailable: true,
    },
];
